module.exports = __webpack_public_path__ + "static/media/LOMPINA_MENU-normal.3c87e1b1.png";